import { useEffect } from "react";

export function useOnScroll(callback: Function) {
  useEffect(() => {
    const updateScrollVars = () => {
      callback();
    };

    const onScroll = () => {
      window.requestAnimationFrame(updateScrollVars);
    };

    updateScrollVars();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
}
